@let user = currentUser$ | async;

<div class="content-container">
  <span class="name"
    ><b>{{ user?.name || ('First name' | translate) }}</b></span
  >
  <span class="username">{{ user?.username || ('User name' | translate) }}</span>
</div>
<tui-data-list role="menu">
  <tui-opt-group>
    @if (this.isDarkTheme) {
      <div class="night">
        <span [class.isActive]="!nightThemeControl.value">{{ 'Light' | translate }}</span>
        <input tuiSwitch type="checkbox" [formControl]="nightThemeControl" />
        <span [class.isActive]="nightThemeControl.value">{{ 'Dark' | translate }}</span>
      </div>
    }

    <button tuiOption (click)="openAccountSettings(user)">
      <tui-icon class="not-hover" [icon]="'common/assets/icons/settings.svg'" />
      <span class="tui-space_left-2">{{ 'My settings' | translate }}</span>
    </button>

    @if (systemType === 'monitoring' && accessLocators) {
      <button tuiOption (click)="openLocatorPopup()">
        <tui-icon class="not-hover" [icon]="'common/assets/icons/geozones.svg'" />
        <span class="tui-space_left-2">{{ 'Locator' | translate }}</span>
      </button>
    }

    @if (isVisibleDocumentationLink) {
      <a href="https://docs.axenta.tech/" target="_blank">
        <button tuiOption class="doc">
          <tui-icon class="not-hover" icon="@tui.external-link" />
          <span class="tui-space_left-2">{{ 'Documentation' | translate }}</span>
        </button>
      </a>
    }

    <button tuiOption (click)="exit()">
      <tui-icon class="not-hover" [icon]="'common/assets/icons/logoutLogin.svg'" />
      <span class="tui-space_left-2">{{ 'Logout' | translate }}</span>
    </button>
  </tui-opt-group>
</tui-data-list>
